import i18n from '@online-offer/i18n';
import {Box, Display, Image, Link, Show, Text, VStack} from 'platform/foundation';
import {z} from 'zod';

import {ComponentType, useState} from 'react';

import {Nullish} from 'shared/web';

import carNotFoundImage from '../../assets/car-not-found.svg?url';

interface NotFoundPageProps {
  ContactSellerButton: ComponentType<{
    onClick: VoidFunction;
    title: string;
    variant: 'secondary';
  }>;
  sellerEmail: string | Nullish;
}

export function NotFoundPage(props: NotFoundPageProps) {
  const emailSchema = z.string().email();
  const isValidEmail = emailSchema.safeParse(props.sellerEmail);
  const [isButtonOpened, setIsButtonOpened] = useState(false);
  const ContactSellerButton = props.ContactSellerButton;

  return (
    <VStack height="100vh" justify="center" align="center">
      <VStack spacing={8} width="100%" align="center" maxWidth={130}>
        <Image
          src={carNotFoundImage}
          alt="Digital Deal not found illustration"
          height={35}
          width="auto"
          isLazy
        />
        <Box paddingHorizontal={6}>
          <VStack spacing={6} justify="center" align="center">
            <Display size={1}>{i18n.t('notFoundPage.title')}</Display>
            <Text align="center">{i18n.t('notFoundPage.description')}</Text>
            <Show when={isValidEmail.success}>
              <ContactSellerButton
                variant="secondary"
                title={i18n.t('notFoundPage.contactSeller')}
                onClick={() => {
                  setIsButtonOpened(true);
                  window.location.href = `mailto:${isValidEmail.data}`;
                }}
              />
              <Show when={isButtonOpened}>
                <VStack justify="center" align="center">
                  <Text align="center">{i18n.t('notFoundPage.copyEmailText')}</Text>
                  <Link href={`mailto:${isValidEmail.data}`} title={isValidEmail.data} />
                </VStack>
              </Show>
            </Show>
          </VStack>
        </Box>
      </VStack>
    </VStack>
  );
}
